
import React from "react";
import {
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { RoutesPaths } from "../Router/constant";

export default function AdminDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  // Adminmanagement page se passed admin object
  const admin = location.state?.admin;

  console.log("Admin Details:", admin);

  const adminName =
    admin?.fullName ||
    admin?.name ||
    admin?.username ||
    "N/A";

  const formattedDate = admin?.createdAt
    ? new Date(admin.createdAt).toLocaleDateString("en-GB")
    : "N/A";

  const dobValue =
    admin?.dob ||
    admin?.dateOfBirth ||
    admin?.birthDate;

  const formattedDob = dobValue
    ? new Date(dobValue).toLocaleDateString("en-GB")
    : "N/A";

  return (
    <div className="container-fluid">
      <div className="row dashboardSection">

        {/* Breadcrumb */}
        <div className="col-md-12">
          <div className="logisticsMenu">
            <p>
              <NavLink to={RoutesPaths.DASHBOARD}>
                <img
                  src="/assets/img/homeIcon.svg"
                  alt=""
                />
              </NavLink>
            </p>

            <img
              src="/assets/img/chevron-right.svg"
              alt=""
            />

            <p>
              <NavLink
                to={RoutesPaths.ADMINMANAGEMENT}
                style={{
                  cursor: "pointer",
                }}
              >
                Admin management
              </NavLink>
            </p>

            <img
              src="/assets/img/chevron-right.svg"
              alt=""
            />

            <p className="m-0">
              Admin details
            </p>
          </div>
        </div>

        {/* Admin Details */}
        <div className="col-md-12">
          <div className="bookingDetailsMain bookingManagementMain">
            <div className="bookingDetailsOuter">

              {/* Heading */}
              <div className="bookingDetailsAlign">
                <h6 className="bookingDetailsTitle p-0">
                  Admin details
                </h6>
              </div>

              {admin ? (
                <div
                  style={{
                    padding: "25px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(2, minmax(0, 1fr))",
                      gap: "25px",
                    }}
                  >

                    {/* Full Name */}
                    <div>
                      <p
                        style={{
                          marginBottom: "6px",
                          color: "#777",
                          fontSize: "13px",
                        }}
                      >
                        Full name
                      </p>

                      <h6 className="m-0">
                        {adminName}
                      </h6>
                    </div>

                    {/* Email */}
                    <div>
                      <p
                        style={{
                          marginBottom: "6px",
                          color: "#777",
                          fontSize: "13px",
                        }}
                      >
                        Email
                      </p>

                      <h6 className="m-0">
                        {admin?.email || "N/A"}
                      </h6>
                    </div>

                    {/* Date of Birth */}
                    <div>
                      <p
                        style={{
                          marginBottom: "6px",
                          color: "#777",
                          fontSize: "13px",
                        }}
                      >
                        Date of birth
                      </p>

                      <h6 className="m-0">
                        {formattedDob}
                      </h6>
                    </div>

                    {/* Created Date */}
                    <div>
                      <p
                        style={{
                          marginBottom: "6px",
                          color: "#777",
                          fontSize: "13px",
                        }}
                      >
                        Created date
                      </p>

                      <h6 className="m-0">
                        {formattedDate}
                      </h6>
                    </div>

                  </div>

                  {/* Back Button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "30px",
                    }}
                  >
                    <button
                      type="button"
                      className="createOrderBtnDetail"
                      onClick={() =>
                        navigate(
                          RoutesPaths.ADMINMANAGEMENT
                        )
                      }
                    >
                      Back
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    padding: "30px",
                    textAlign: "center",
                  }}
                >
                  <p className="noOrders">
                    Admin details not available
                  </p>

                  <button
                    type="button"
                    className="createOrderBtnDetail"
                    onClick={() =>
                      navigate(
                        RoutesPaths.ADMINMANAGEMENT
                      )
                    }
                  >
                    Back to admin management
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
